// extracted by css-extract-rspack-plugin
export default {"notice":"aLFrVZvgE70GRGiV"};